export default Object.freeze({
  NOT_ALLOWED: 'NOT_ALLOWED',
  OPTIONAL: 'OPTIONAL',
  MANDATORY: 'MANDATORY',
})
